import TokenAnalyzerStatItem from "./TokenAnalyzerStatItem";

export default TokenAnalyzerStatItem;